import { DealPlanButton } from '../DealPlanButton';
import { EGeneralPlanList } from '../../PlansUtils';
import { FreemiumPlanButton } from '../FreemiumPlanButton';
import { PAYGPlanButton } from '../PAYGPlanButton';

export interface ActionButtonProps {
  className?: string;
  isCurrentPlanTextShort?: boolean;
  onClick?: () => void;
  planName: EGeneralPlanList;
}

export const ActionButton = ({
  className,
  isCurrentPlanTextShort = false,
  onClick,
  planName,
}: ActionButtonProps) => {
  if (planName === EGeneralPlanList.Deal) {
    return (
      <DealPlanButton
        className={className}
        isCurrentPlanTextShort={isCurrentPlanTextShort}
        onClick={onClick}
      />
    );
  }

  if (planName === EGeneralPlanList.PayAsYouGo) {
    return <PAYGPlanButton className={className} onClick={onClick} />;
  }

  return (
    <FreemiumPlanButton
      className={className}
      isCurrentPlanTextShort={isCurrentPlanTextShort}
      onClick={onClick}
    />
  );
};
